__turbopack_context__.v({
  "className": "telegrafico_c8c250c1-module__LY15JW__className",
  "variable": "telegrafico_c8c250c1-module__LY15JW__variable",
});
